import { createScope, createService } from '@tencent/tiny-ioc';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IOfflineEditContext } from './interfaces/offline-edit-context.interace';
import { IOfflineDBService } from './interfaces/offline-db-service.interface';
import { IOfflineEditService } from './interfaces/offline-edit-service.interface';
import { IOfflineCacheService } from './interfaces/offline-cache-service.interface';

export const OfflineEditServices = createScope(() => {
    // 离线编辑上下文信息
    const OfflineEditContext = createService<IOfflineEditContext>().dependsOn([]);

    // 离线编辑数据库相关服务
    const OfflineDBService = createService<IOfflineDBService>().dependsOn([
        OfflineEditContext,
        SlideDataServices.Infra.Logger,
    ]);

    // 离线编辑手动处理缓存相关服务
    const OfflineCacheService = createService<IOfflineCacheService>().dependsOn([
        OfflineEditContext,
        OfflineDBService,
        SlideDataServices.Infra.Logger,
        SlideDataServices.UI.Snackbar,
    ]);

    // 离线编辑打开文档主服务，跟 online-edit-service 同步初始化
    const OfflineEditService = createService<IOfflineEditService>().dependsOn([
        OfflineEditContext,
        OfflineDBService,
        SlideDataServices.Infra.Logger,
        SlideDataServices.Infra.Mqq,
        SlideDataServices.EventManager,
        SlideDataServices.SDKDataServices.EventManager,
    ]);

    return {
        OfflineEditContext,
        OfflineDBService,
        OfflineCacheService,
        OfflineEditService,
    };
});
